import { styled } from "@mui/material/styles";
import FormHelperTextMui from "@mui/material/FormHelperText";
import { Caption } from "../../BSPCaption";

export const FormHelperText = styled(FormHelperTextMui)`
  ${Caption}
  text-transform: uppercase;
` as unknown as typeof FormHelperTextMui;
